var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('visitor-properties-view',{staticClass:"scrollable",attrs:{"data":_vm.visitorProperties,"loaded":_vm.audienceLoadable.loaded}})}
var staticRenderFns = []

export { render, staticRenderFns }